import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Tooltip, Fade } from '@material-ui/core';

import DatePicker from '../../utils/DatePicker';
import { postData } from '../../../dataLib';

import FloatNumberFormatInput from '../../float_number_input_formatter';

const drawerWidth = 240;

const styles = theme => ({
    root: {
        height: '100%',
        width: drawerWidth
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    }, 
    rtl: {
        textAlign: 'right',
    },
});

class EditFondo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            valor: 0.0,
            fecha: new Date().toJSON().slice(0, 10),
        };
    };

    updateFondo = () => {

        var url = 'DEFondos/maestro?centro_id=' + this.props.centroid;
        url += '&valor=' + this.state.valor;
        url += '&fecha=' + this.state.fecha;
        postData(
            url,
            () => {
                this.props.hideDialog();
                this.props.openDialog('SimpleMessage', {
                    message: 'fondo actualizado'
                },'fondo_actualizado', false, 'sm');
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'error actualizando fondo'
                }, 'fondo_actualizado_error', false, 'sm');
            },
            { },
            this.props.user
        );
    }

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    handleValueChangeDate = (event, field) => {
        this.setState({ ...this.state, [field]: event });
    };

    render() {
        const { classes } = this.props;

        return (
            <form className={classes.root} autoComplete="off">



                <FormControl className={classes.formControl}>
                    <Tooltip title="Fondo de euros" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                        <TextField
                            id={'valor'}
                            label={'Fondo'}
                            placeholder={'Fondo'}
                            className={classes.textField}
                            margin="normal"
                            InputProps={{ classes: { input: classes.rtl }, inputComponent: FloatNumberFormatInput }}
                            value={this.state.valor}
                            onChange={(event) => this.handleValueChange(event, 'valor')}
                        />
                    </Tooltip>
                </FormControl>


                <FormControl className={classes.formControl}>
                    <DatePicker
                        label={'Fecha'}
                        value={this.state.fecha}
                        onChange={event => {
                            if (event && !isNaN(event)) {
                                const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                this.handleValueChangeDate(d.toISOString().slice(0, 10), 'fecha')
                            }
                        }}
                    />
                </FormControl>



                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        this.updateFondo();
                    }
                    }>Guardar</Button>
                </div>

            </form>
        );

    };


};

EditFondo.propTypes = {
    centroid: PropTypes.number.isRequired,
    hideDialog: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditFondo);